import { useState, useEffect } from 'react';

function Cronometro({ datos, prueba, serie, torneoEspecifico }) {
  const [ running, setRunning ] = useState(false);
  const [ startTime, setStartTime ] = useState(null);
  const [ elapsedTime, setElapsedTime ] = useState(0);

  useEffect(() => {
    if (datos.estado === 'start') {
      setStartTime(Date.now());
      setElapsedTime(0);
      setRunning(true);
    } else if (datos.estado === 'stop') {
      setRunning(false);
      setElapsedTime(Date.now() - startTime);
    }
  }, [datos]);

  useEffect(() => {
    let interval;
    if (running) {
      interval = setInterval(() => {
        setElapsedTime(Date.now() - startTime);
      }, 10); // Actualiza cada 10 ms
    } else if (!running && startTime != null) {
      clearInterval(interval);
      organizarTiempo(datos.tiempo);
    }
    return () => clearInterval(interval);
  }, [running, startTime, datos]);

 //const formatTime = (time) => {
  //  const milliseconds = time % 1000;
  //  const seconds = Math.floor(((time / 1000) % 60));
  //  const minutes = Math.floor((time / (1000 * 60)) % 60);
  //  if (document.getElementById(`${prueba - 1}tiempo${datos.carril - 1}minserie${serie}`) !== null) {
  //    document.getElementById(`${prueba - 1}tiempo${datos.carril - 1}minserie${serie}`).value = minutes;
  //    document.getElementById(`${prueba - 1}tiempo${datos.carril - 1}segserie${serie}`).value = seconds;
  //    document.getElementById(`${prueba - 1}tiempo${datos.carril - 1}miliserie${serie}`).value = milliseconds;
  //  }
  //  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}:${milliseconds < 10 ? '00' : milliseconds < 100 ? '0' : ''}${milliseconds}`;
  //};

  const organizarTiempo = (tiempo) =>{
    if(tiempo !== '0:0:0'){
      const [minutos, segundos, milisegundos] = tiempo.split(':').map(Number);
      const ms = (minutos * 60000) + (segundos * 1000) + milisegundos;
      if (ms >= 0 && ms <= 8000) {
        if (document.getElementById(`${prueba - 1}tiempo${datos.carril}minserie${serie}`) !== null) {
          document.getElementById(`${prueba - 1}tiempo${datos.carril}minserie${serie}`).value = 0;
          document.getElementById(`${prueba - 1}tiempo${datos.carril}segserie${serie}`).value = 0;
          document.getElementById(`${prueba - 1}tiempo${datos.carril}miliserie${serie}`).value = 0;
        }
      }else{
        if (document.getElementById(`${prueba - 1}tiempo${datos.carril}minserie${serie}`) !== null) {
          document.getElementById(`${prueba - 1}tiempo${datos.carril}minserie${serie}`).value = minutos;
          document.getElementById(`${prueba - 1}tiempo${datos.carril}segserie${serie}`).value = segundos;
          document.getElementById(`${prueba - 1}tiempo${datos.carril}miliserie${serie}`).value = milisegundos;
        }
      }
    }

    return tiempo;
  }

  return (
    datos.carril >= parseInt(torneoEspecifico.carrilInicio) && datos.carril <= parseInt(torneoEspecifico.carrilFin) ?(
      <div className='p-1 text-center mb-2 text-white' style={{borderRadius: '20px', width: '170px', background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 60%, rgba(0, 212, 255, 1) 100%)'}}>
        <span style={{ fontSize: '30px' }}>{(running ? "Corriendo" : datos.tiempo ? datos.tiempo : '0:0:0')}</span>
        <div className='d-flex justify-content-around'>
          <span className='border rounded-3 p-1' style={{ fontSize: '14px' }}>{"P - " + prueba} </span>
          <span className='border rounded-3 p-1' style={{ fontSize: '14px' }}>{"S - " + serie} </span>
          <span className='border rounded-3 p-1' style={{ fontSize: '14px' }}>{"C - " + datos.carril} </span>
        </div>
      </div>
    ):(
      <></>
    )
  );
}

export default Cronometro;